const menuOffers = function() { 
    if (document.getElementsByTagName('body')[0].classList.contains('page-template-page-offers')) {
        const menuClose = document.querySelector('.page-template-page-offers #my-offers .menu-icons .close');
        const menuOpen = document.querySelector('.page-template-page-offers #my-offers .menu-icons .open');
        menuClose.addEventListener('click', function() {
            document.querySelector('.page-template-page-offers #my-offers').classList.add('menu-close');
            document.querySelector('.page-template-page-offers #my-offers').classList.remove('menu-open');
        })
        menuOpen.addEventListener('click', function() {
            document.querySelector('.page-template-page-offers #my-offers').classList.add('menu-open');
            document.querySelector('.page-template-page-offers #my-offers').classList.remove('menu-close');
        })
    }
}

addFunctionOnWindowLoad(menuOffers);